import { render, staticRenderFns } from "./OpenBets.vue?vue&type=template&id=6e53fff1&scoped=true&"
import script from "./OpenBets.vue?vue&type=script&lang=js&"
export * from "./OpenBets.vue?vue&type=script&lang=js&"
import style0 from "./OpenBets.vue?vue&type=style&index=0&id=6e53fff1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e53fff1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
